module.exports = __webpack_public_path__ + "img/38.d4dd3a27.jpg";